import React, { useEffect, useState } from 'react'
import { Row, Col } from "antd";


const Exito = ({mensaje}) => {
    return (
		<div id={'conexion-exito'} className={`h-100`}>
			<Row justify="center" className="align-items-stretch h-100" style={{    height: "auto"}}>
				<Col xs={20} sm={20} md={24} lg={16}>
					<div>
						<h2 className='title-message'>{mensaje && mensaje.titulo}</h2>
                        <p>{mensaje && mensaje.mensaje}</p>
					</div>
				</Col>
			</Row>
            <Row>
            <div >
				<div className='footer-exito'>
                    <div style={{maxWidth: "100px"}}>
                        Funciona con <img style={{width:'100%'}} src="/img/virtud-horizontal.webp" alt="Logo VIRTUD" />
                    </div>
					<a  href={'https://virtud.cloud/tyc'} target='_blank'>Términos y condiciones</a>
					<a  href={'https://virtud.cloud/aviso-privacidad'} target='_blank'>Aviso de Privacidad</a>
				</div>
			</div>
					
            </Row>
		</div>
    );
};

export default Exito;